<template>
  <div class="m-drawer">
    <!-- size="38%" -->
    <el-drawer v-model="show" v-bind="$attrs" size="736" :show-close="false">
      <template #header>
        <slot name="header">
          <font-icon @click="handleClose" icon="icon-shan" />
          <span class="close-text">{{ $t("shared.common.Close") }}</span>
        </slot>
      </template>
      <div class="drawer-body">
        <slot name="title">
          <div class="title">{{ title }}</div>
        </slot>

        <slot>
          <div class="drawer-content" v-html="safeContent" />
        </slot>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ElDrawer } from "element-plus";
import { computed } from "vue";
const props = defineProps({
  title: {
    type: String,
    default: ""
  },
  content: {
    type: String,
    default: "123"
  }
});
const show = defineModel({ type: Boolean, default: false });

function sanitizeHTML(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  // 选择性过滤，例如移除 <script> 标签
  const scripts = doc.querySelectorAll("script");
  scripts.forEach(script => script.remove());

  // 其他过滤逻辑可以加入这里
  return doc.body.innerHTML;
}
const handleClose = () => {
  show.value = false;
};
const safeContent = computed(() => {
  return sanitizeHTML(props.content);
});
</script>

<style lang="scss" scoped>
.m-drawer {
  :deep(.el-drawer__header) {
    & > :first-child {
      flex: 0;
      margin-right: 32px;
      cursor: pointer;
    }
  }
  .drawer-body {
    padding: 0 36px 48px;
    .title {
      font-weight: bold;
      font-size: 48px;
      color: #292929;
      line-height: 48px;
      text-align: left;
      margin-bottom: 36px;
    }
    .drawer-content {
      font-weight: 400;
      font-size: 20px;
      color: #696969;
    }
  }
}
</style>
